import React, {useEffect, useMemo, useRef, useState} from "react";
import dayjs from "dayjs";
import {constantsErrorMessages} from "../../../../Constants";
import DateTimeUtil from "../../../../utils/common/DateTimeUtil";
import MaterialWarehouseService from "../../../../API/orders/warehouse/material/MaterialWarehouseService";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import DateTimeInput from "../../../../components/UI/filter/DateTimeInput";
import ButtonCreate from "../../../../components/UI/button/ButtonCreate";
import {Checkbox, TextField} from "@mui/material";
import ButtonExport from "../../../../components/UI/button/ButtonExport";
import FileDownloadController from "../../../../API/organization/FileDownloadController";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import FormControlLabel from "@mui/material/FormControlLabel";
import BalanceSheetTable from "./BalanceSheetTable";
import MenuItem from "@mui/material/MenuItem";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import {BalanceSheetTableFilterData} from "../../../../data/FilterTables/BalanceSheetTableFilterData";

const BalanceSheet = () => {
    const [startData, setStartData] = useState(dayjs(Date.now()));
    const [endData, setEndData] = useState(dayjs(Date.now()));
    const [skipZero, setSkipZero] = useState(false)
    const [dataAll, setDataAll] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [reportReceived, setReportReceived] = useState(false);
    const [filteredData, setFilteredData] = useState(dataAll)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const profile = JSON.parse(localStorage.getItem("profile"))
    const [baseCurrency, setBaseCurrency] = useState(profile?.baseCurAbbreviation);
    const [alternativeCurrency, setAlternativeCurrency] = useState(profile?.alternativeCurAbbreviation);
    const [selectCurrency, setSelectCurrency] = useState(1)
    const currency = [
        {tab: 1, type: "baseCurrency", value: profile?.baseCurAbbreviation},
        {tab: 2, type: "alternativeCurrency", value: profile?.alternativeCurAbbreviation}]

    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const handleChangeSelect = (currentCurrency) => {
        setSelectCurrency(currentCurrency)
        EditLocalStoragePagesData("/organization/balance-sheet", "currency", currentCurrency)
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, BalanceSheetTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [BalanceSheetTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`/organization/balance-sheet`, "searchQuery", searchQuery)
            }
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`/organization/balance-sheet`]?.pageSize
        const searchQuery = pagesData[`/organization/balance-sheet`]?.searchQuery

        return {searchQuery, pageSize}
    }
    useEffect(() => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const currency = pagesData["/organization/balance-sheet"]?.currency
        currency && setSelectCurrency(currency)
    }, [])

    const applyAllBalanceSheet = () => {
        const {searchQuery, pageSize} = getStartPageSize()
        MaterialWarehouseService.getAllBalanceSheet(DateTimeUtil.convertToJavaDateTime(startData), DateTimeUtil.convertToJavaDateTime(endData), skipZero).then(function (response) {
            const data = response.data;
            setDataAll(data);
            setReportReceived(true)
            handleSearchQuery(searchQuery, data, pageSize)
            handleModalAlert("Отчёт получен", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`/organization/balance-sheet`, "pageSize", nextState.pageSize)
        }
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Оборотная ведомость"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                Оборотная ведомость
            </Typography>
            <Box sx={{display: "flex", gap: "50px", paddingTop: "30px"}}>
                <Box sx={{display: "flex", gap: "20px", alignItems: "end"}}>
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '0.5rem',
                            flexWrap: 'wrap',
                            alignItems: "end"
                        }}>
                        <DateTimeInput
                            value={startData}
                            setValue={setStartData}
                            variant={"outlined"}
                        />
                        <DateTimeInput
                            value={endData}
                            setValue={setEndData}
                            variant={"outlined"}
                        />
                        <FormControlLabel
                            control={<Checkbox
                                onChange={() => setSkipZero(!skipZero)}
                                checked={skipZero}
                            />}
                            label="Пропустить нулевые значения"
                        />
                    </Box>
                </Box>
            </Box>
            <Box sx={{padding: "30px 0", display: 'flex', gap: "10px",}}>
                <ButtonCreate
                    text={"Получить полный отчёт"}
                    onClick={applyAllBalanceSheet}
                    icon={false}
                    width={200}
                    height={43}
                    disabled={!startData || !endData}/>
                <ButtonExport
                    text={"Скачать отчёт"}
                    width={130}
                    height={43}
                    api={() => FileDownloadController.exportMaterialsBalanceSheet(DateTimeUtil.convertToJavaDateTime(startData), DateTimeUtil.convertToJavaDateTime(endData), skipZero)}
                    handleModalAlert={handleModalAlert}/>
                <TextField
                    sx={{width: "240px"}}
                    size="small"
                    select
                    label="Валюта"
                    value={selectCurrency}
                    onChange={(e) => handleChangeSelect(e.target.value)}
                >
                    {currency.map((option) => (
                        <MenuItem key={option.tab} value={option.tab}>
                            {option.value}
                        </MenuItem>))}
                </TextField>
            </Box>

            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
            {reportReceived &&
                <BalanceSheetTable
                    data={dataAll}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    baseCurrency={baseCurrency}
                    alternativeCurrency={alternativeCurrency}
                    selectCurrency={selectCurrency}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                />}
        </Box>

    );
}
export default BalanceSheet